import BaseService from "../index";

export default {
    get() {
        return BaseService.get(`/cms/error-page`);
    },

    update(params) {
        return BaseService.put(`/cms/error-page`, params);
    },
};
